import {
  Breadcrumb,
  Typography,
  Button,
  Row,
  Col,
  Modal,
  Input,
  Form,
  message,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import lang from "src/lang";
import TinyMCEEditor from "src/common/base/Editor";
import TermsConditionsTable from "./TermsConditionsTable";

const { Title, Text } = Typography;

const TermsConditions: React.FC = () => {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  const handleAddNoteClick = () => {
    setIsModalVisible(true);
  };

  const handleModalOk = () => {
    form
      .validateFields()
      .then((values) => {
        console.log("New Terms Entry:", values);
        message.success(lang.get("settings", ["Entry added successfully"]));
        setIsModalVisible(false);
        form.resetFields();
      })
      .catch(() => {});
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f5f7fa",
        minHeight: "100vh",
      }}
    >
      {/* Breadcrumb */}
      <Breadcrumb style={{ marginBottom: "16px" }} separator=">">
        <Breadcrumb.Item>{lang.get("settings", ["Home"])}</Breadcrumb.Item>
        <Breadcrumb.Item>{lang.get("settings", ["Predifined Notes"])}</Breadcrumb.Item>
        <Breadcrumb.Item>{lang.get("settings", ["Terms & Conditions"])}</Breadcrumb.Item>
      </Breadcrumb>

      {/* Page Title */}
      <Title level={2} style={{ marginBottom: "16px" }}>
        {lang.get("settings", ["Terms & Conditions"])}
      </Title>

      {/* Action Button */}
      <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
        <Col xs={24} sm={12} md={12} lg={12} style={{ textAlign: "left" }}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleAddNoteClick}
          >
            {lang.get("settings", ["New Note"])}
          </Button>
        </Col>
      </Row>

      <TermsConditionsTable />

      {/* Add Terms Modal */}
      <Modal
        title={lang.get("settings", ["Add Terms & Conditions"])}
        visible={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okText={lang.get("settings", ["Save"])}
        cancelText={lang.get("settings", ["Cancel"])}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="term"
            label={<Text style={{ fontSize: 14 }}>{lang.get("settings", ["Terms"])}</Text>}
            rules={[{ required: true, message: lang.get("settings", ["Please enter the term"]) }]}
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item
            name="condition"
            label={<Text style={{ fontSize: 14 }}>{lang.get("settings", ["Conditions"])}</Text>}
            rules={[{ required: true, message: lang.get("settings", ["Please enter the condition"]) }]}
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item
            name="description"
            label={<Text style={{ fontSize: 14 }}>{lang.get("settings", ["Description"])}</Text>}
            rules={[{ required: true, message: lang.get("settings", ["Please enter the description"]) }]}
          >
            <TinyMCEEditor />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default TermsConditions;
